import { createDefaultPanel } from 'features/charts-v2/store'
import type { SelectedFilterOption } from 'features/charts-v2/types'
import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'

/**
 * A default panel carrying only the given filters — for a request whose route
 * reads a panel's filters and nothing else (filter-option counts). Chart type,
 * metrics and breakdowns are the defaults and never read by those routes.
 */
export function buildFiltersPanel(
  filters: readonly SelectedFilterOption[],
): ChartPanel {
  return { ...createDefaultPanel(0), filters: [...filters] }
}
